export default __webpack_public_path__ + "static/media/sunrise_empty.a2deba2c.svg";